<app-filter [tableName]="'idiomas'"></app-filter>

<app-table [tableName]="'idiomas'"></app-table>

<app-panelcustoman
  *ngIf="customanpanel !== undefined"
  [ConfigPanel]="customanpanel"
  [pkId]="customanPkId"
  [mode]="customanMode"
  [modificar]="true"
></app-panelcustoman>
